var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useId } from 'react';
import { mergeProps, useRender } from '@base-ui/react';
export const MenuInput = forwardRef((props, ref) => {
    const { id, render } = props, rest = __rest(props, ["id", "render"]);
    const generatedId = useId();
    const inputId = id || generatedId;
    const handleKeyDown = (event) => {
        // This is to stop the menu's typeahead functionality
        event.stopPropagation();
        const menuItems = document.querySelectorAll('[role="menuitem"]');
        if (event.key === 'ArrowDown') {
            const first = menuItems[0];
            first === null || first === void 0 ? void 0 : first.focus();
        }
        if (event.key === 'ArrowUp') {
            const last = menuItems[menuItems.length - 1];
            last === null || last === void 0 ? void 0 : last.focus();
        }
    };
    const element = useRender({
        render,
        props: mergeProps({
            id: inputId,
            onKeyDown: handleKeyDown,
            ref,
        }, rest),
    });
    return element;
});
